/**
 * helper used in both gatsby‑browser and gatsby‑ssr
 * This ensure that Material‑UI v5 gets a theme and always portals into the Gatsby root element
 */

import { createTheme } from "@mui/material/styles"
import { defaultTheme } from "../lib/styled-system/constants"

const getPortalContainer = () =>
  typeof document !== "undefined"
    ? document.getElementById("___gatsby") || document.body
    : undefined

export const muiTheme = createTheme({
  spacing: defaultTheme.space,
  breakpoints: {
    values: {
      _: 0,
      xs: defaultTheme.breakpoints.xs,
      sm: defaultTheme.breakpoints.sm,
      md: defaultTheme.breakpoints.md,
      lg: defaultTheme.breakpoints.lg,
      xl: defaultTheme.breakpoints.xl,
    },
  },
  typography: { fontFamily: "DM Sans" },
  palette: {
    primary: { main: "#4462ff" },
  },
  /* ensure every portal stay inside Gatsby root #___gatsby */
  components: {
    MuiPopover: { defaultProps: { container: getPortalContainer } },
    MuiPopper: { defaultProps: { container: getPortalContainer } },
    MuiMenu: { defaultProps: { container: getPortalContainer } },
    MuiDialog: { defaultProps: { container: getPortalContainer } },
    MuiModal: { defaultProps: { container: getPortalContainer } },
  },
})
